import {Color} from "finhelper";

export function addCurrentDateMarker(dateAxis, am4core) {
    const range = dateAxis.axisRanges.create();
    range.date = new Date();
    range.grid.stroke = am4core.color("#4378FF");
    range.grid.strokeWidth = 2;
    range.grid.strokeOpacity = 1;
    range.label.text = 'Сегодня';
    range.label.fontWeight = '600';
    range.label.fill = am4core.color("#000");
    range.label.valign = 'top';
    range.label.dy = -30;
    range.label.adapter.add("horizontalCenter", () => "middle");
    range.label.align = 'center';
    range.label.inside = true;
    range.label.rotation = 0;
}

export function setupScrollbar(chart, am4core) {
    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarX.parent = chart.chartAndLegendContainer;
    chart.scrollbarX.startGrip.disabled = true;
    chart.scrollbarX.endGrip.disabled = true;
    chart.scrollbarX.minHeight = 8;
}

export function setupCategoryLabels(categoryAxis, showPercents) {
    categoryAxis.renderer.labels.template.adapter.add("htmlOutput", function (text, item) {
        if (text === '') return '';

        let html = typeof text === 'string' ? text.capitalize() : '';
        let color = '';
        let mainColor = '';
        let percentText = '';

        if (item?.dataItem?.dataContext) {
            mainColor = item.dataItem.dataContext.color;
            color = Color.increaseBrightness(mainColor, 25);

            if (showPercents && typeof item.dataItem.dataContext.percent !== 'undefined') {
                percentText = ` ${Math.round(item.dataItem.dataContext.percent)}%`;
            }
        }

        return `<div style="${mainColor ? `background-color: ${color};` : ''} height: 20px; border-radius: 8px; min-width: 30px; line-height: 17px; padding: 2px 6px 3px 6px;">
      <div style="text-align: left; padding: 4px 10px 5px 10px; border-radius: 8px; line-height: 11px; display: inline-block; font-size: 14px; font-weight: 400;">
        ${html}${percentText}
      </div>
    </div>`;
    });

    categoryAxis.renderer.labels.template.adapter.add("html", function () {
        return "{name}";
    });
}